import React from 'react';
import {Link} from 'react-router-dom';
import {DownloadReportModal} from "react-spaceship-web";

export default class TemporaryReceipt extends React.Component {
	constructor(props) {
		super(props);

		let _state = {};
		window.Route.on({
			'/v2/temporary-receipts': () => {
				_state = {
					mode: 'list',
					temporary_receipts: [],
				};
			},
			'/v2/temporary-receipts/:temporary_receipt_id': (params) => {
				_state = {
					mode: 'view',
					params: params,
					temporary_receipts: [],
				};
			}
		}).match();

		this.state = _state;
	}

	fetch() {
		this.setState({
			is_loading: true,
			temporary_receipts: [],
		});

		let data = window.Global.getAllQueryStrings();

		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/v1/temporary_receipt',
			data: data,
			done: (response) => {
				this.setState({
					is_loading: false,
					temporary_receipts: response.temporary_receipt
				}, () => {
					if (response.relationship) {
						this.$parent.find('form').find('input[name="relationship_id"]').explorer('set value', response.relationship);
					}
					if (response.relationship_branch) {
						this.$parent.find('form').find('input[name="relationship_branch_id"]').explorer('set value', response.relationship_branch);
					}
					if (response.created_user) {
						this.$parent.find('form').find('input[name="created_user_id"]').explorer('set value', response.created_user);
					}

					this.$parent.find('.Table_root').tablePagination({
						disableContent: true,
						data: response.temporary_receipt,
						count: response.count,
						onClickPagination: (p) => {
							let qs = window.Global.getAllQueryStrings();
							qs.page = p;
							this.props.history.push(window.Global.getQueryStringLinkFromObject(qs));
						}
					});
				});
				// window.Route.setLink();
			},
			fail: () => {

			}
		});
	}

	view() {
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/v1/temporary_receipt',
			data: {
				temporary_receipt_id: this.state.params.temporary_receipt_id,
			},
			done: (response) => {
				let temporary_receipt = response['temporary_receipt'][0];

				this.$parent.find('form').form2('init', {
					data: temporary_receipt
				});

				this.setState({
					temporary_receipt: temporary_receipt
				});

				// window.GlobalFunc.showSummary2(
				// 	this.$parent.find('.Summary_root'),
				// 	temporary_receipt.summary,
				// 	{
				// 		tax: true
				// 	}
				// );
			},
			fail: () => {

			}
		});
	}

	componentDidMount() {
		if (this.state.mode === 'list') {
			this.fetch();
		}

		if (this.state.mode === 'view') {
			this.view();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		// console.log(this.props.location);
		if (this.props.location.pathname !== prevProps.location.pathname) {
			window.Route.on({
				'/v2/temporary-receipts': () => {
					this.setState({
						mode: 'list'
					}, () => {
						this.fetch();
					})
				},
				'/v2/temporary-receipts/:temporary_receipt_id': (params) => {
					this.setState({
						mode: 'view',
						params: params,
					}, () => {
						this.view();
					});
				}
			}).match();
		} else if (this.props.location.search !== prevProps.location.search) {
			this.fetch();
		}
	}

	renderList() {
		return (
			<div ref={(ref) => {
				if (!ref) return;
				this.$parent = window.$(ref);
			}}
				 key={'ddd' + window.Global.getRandomInt(1, 99999999)}
				 className="main ui container">
				<div style={{marginBottom: '1rem'}}>
					<div className="flex row wrap middle-xs">
						<div className="ui huge breadcrumb">
							<Link className="section active"
								  to="/v2/temporary-receipts">
								ใบเสร็จรับเงินชั่วคราว
							</Link>
						</div>
					</div>
					<div id="Search_root" className="box" style={{display: 'none', marginTop: '1rem'}}
						 ref={(ref) => {
							 let $search = window.$(ref);

							 window.Search.init({
								 $node: $search,
								 onSubmit: (data) => {
									 this.props.history.push(window.Global.getQueryStringLinkFromObject(data));
									 return false;
								 }
							 });

							 $search.find('input[name="relationship_id"]').explorer({
								 url: process.env.REACT_APP_DOMAIN + '/api/relationship',
								 additionalData: {
									 limit: 10,
									 page: 1
								 },
								 key: 'relationship',
								 template: {
									 list: '<a class="item flex row">{{name}}</a>',
									 selected: {
										 text: 'name',
										 value: 'id',
										 placeholder: 'คู่ค้า'
									 }
								 },
								 onSelected: () => {
									 this.$parent.find('input[name="relationship_branch_id"]').explorer('clear');
								 }
							 });
							 $search.find('input[name="relationship_branch_id"]').explorer({
								 url: process.env.REACT_APP_DOMAIN + '/api/relationship/branch',
								 additionalData: () => {
									 let relationship_id = this.$parent.find('*[name="relationship_id"]').val();
									 return {
										 limit: 10,
										 relationship_id: relationship_id || false
									 }
								 },
								 key: 'relationship_branch',
								 template: {
									 list: '<a class="item">\n\t<div class="flex row wrap between-xs">\n\t\t<div>{{name}}</div>\n\t\t<b style="color: darkgreen;flex-shrink: 0;">{{code}}</b>\n\t</div>\n</a>',
									 selected: {
										 display_template: '{{name}} {{code}}',
										 value: 'id',
										 placeholder: 'สาขา'
									 }
								 }
							 });
							 $search.find('input[name="created_user_id"]').explorer({
								 url: process.env.REACT_APP_DOMAIN + '/api/user',
								 additionalData: () => {
									 return {
										 limit: 10
									 }
								 },
								 key: 'user',
								 template: {
									 list: '<a class="item">\n\t<div class="flex row wrap between-xs">\n\t\t<b style="color: darkgreen;">{{name}}</b>\n\t</div>\n</a>',
									 selected: {
										 display_template: '{{name}}',
										 value: 'id',
										 placeholder: 'ผู้บันทึก'
									 }
								 }
							 });
							 $search.find('#download-pdf-button').on("click", () => {
								 let data = $search.find('form').serializeObject();
								 data.is_download_excel = true;
								 window.Global.reactToDom(
									 window.$('body'),
									 <DownloadReportModal
										 url={process.env.REACT_APP_DOMAIN + '/api/v1/temporary_receipt'}
										 data={data}
									 />
								 );
							 })
						 }}>
						<form className="ui form">
							<div className="flex row wrap padded five column computer">
								<div className="column field">
									<div className="field">
										<label>เลขที่เอกสาร</label>
										<input type="text" name="search_query" placeholder="เลขที่เอกสาร"/>
									</div>
								</div>
								<div className="column field">
									<div className="field">
										<label>คู่ค้า</label>
										<input type="text" name="relationship_id"/>
									</div>
								</div>
								<div className="column field">
									<div className="field">
										<label>สาขา</label>
										<input type="text" name="relationship_branch_id"/>
									</div>
								</div>
								<div className="column field">
									<div className="field">
										<label>ช่วงวันที่</label>
										<div data-form_calendar="date"
											 data-input_name="start_doc_date"
											 data-placeholder="ช่วงวันที่"
											 data-end_calendar="end_doc_date"
											 data-locale="th"
											 data-initialdate=""
										/>
									</div>
								</div>
								<div className="column field">
									<div className="field">
										<label>ถึงวันที่</label>
										<div data-form_calendar="date"
											 data-input_name="end_doc_date"
											 data-placeholder="ถึงวันที่"
											 data-start_calendar="start_doc_date"
											 data-locale="th"
											 data-initialdate=""
										/>
									</div>
								</div>
								<div className="column field">
									<div className="field">
										<label>ผู้บันทึก</label>
										<input type="text" name="created_user_id"/>
									</div>
								</div>
								<div className="column field">
									<div className="field">
										<label>สถานะ</label>
										<select name="status"
												className="ui dropdown fluid"
												data-form2_setup="">
											<option value="">สถานะ</option>
											<option value="wait_approve">รอตรวจสอบ</option>
											<option value="approve">ตรวจสอบเรียบร้อย</option>
											<option value="void">ยกเลิก</option>
										</select>
									</div>
								</div>
								<div className="column field">
									<label>เรียงข้อมูล</label>
									<div className="field">
										<select className="ui dropdown"
												name="order_by"
												data-form2_setup="">
											<option value="oldest">วันที่จากวันที่ 1 ไปถึง 30</option>
											<option value="newest">วันที่จากวันที่ 30 ไปถึง 1</option>
										</select>
									</div>
								</div>
								<div className="column fluid right floated">
									<label style={{opacity: 0}}>อื่นๆ</label>
									<div className="flex row wrap right floated end-xs">
										<button id="download-pdf-button"
												className="ui positive button"
												type="button">พิมพ์รายงาน
										</button>
										<button className="ui icon button green"
												type="submit">
											<i className="search icon"/> ค้นหา
										</button>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
				<div className="flex row wrap padded">
					<div className="col-xs-16 padded">
						<div className="ui basic table can click Table_root td-top-xs" style={{marginTop: 0}}>
							<div className="thead">
								<div className="tr">
									<div className="th span2 row">
										{/*<div className="ui checkbox" data-form2_setup="true">*/}
										{/*	<input type="checkbox"*/}
										{/*	       name="select_all"*/}
										{/*	       value={"select_all"}*/}
										{/*	       onChange={() => {*/}
										{/*		       this.onAllSelected();*/}
										{/*	       }}*/}
										{/*	       checked={this.isAllSelected()}*/}
										{/*	/>*/}
										{/*	<label/>*/}
										{/*</div>*/}
										วันที่
									</div>
									<div className="th span2">เลขที่</div>
									<div className="th span4">ลูกค้า</div>
									<div className="th span4">สถานะ</div>
									<div className="th span2">ผู้บันทึก</div>
									<div className="th span2">การตรวจสอบ</div>
									<div className="th span2">จำนวนเงิน</div>
								</div>
							</div>
							<div className="tbody">
								{
									this.state.is_loading
										? <div className="tr">
											<div className="td center aligned" data-info="nodata">
												<div className="ui active centered inline small loader"/>
											</div>
										</div>
										: null
								}
								{
									this.state.temporary_receipts.length === 0
									&& !this.state.is_loading
									&& (
										!window.Global.getAllQueryStrings().page
										|| window.Global.getAllQueryStrings().page === '1'
									)
										? <div className="tr">
											<div className="td span16" style={{textAlign: 'center'}}>ไม่พบข้อมูล</div>
										</div>
										: null
								}
								{
									this.state.temporary_receipts.map((temporary_receipt, temporary_receipt_index) => {
										return (
											<Link className="tr"
												  to={temporary_receipt.url}
												  key={temporary_receipt_index}>
												<div className="td span2">
													<div>{window.Global.getDateThai(temporary_receipt.doc_date)}</div>
												</div>
												<div className="td span2">
													<div>{temporary_receipt.doc_no}</div>
												</div>
												<div className="td span4">
													<div>{temporary_receipt.temporary_receipt_header.b_name}</div>
													<div>{temporary_receipt.temporary_receipt_header.b_branch_name}</div>
												</div>
												<div className="td span4">
													{this.getStatus(temporary_receipt)}
												</div>
												<div className="td span2">
													<div>{temporary_receipt.created_user.name}</div>
													<div>{window.Global.getDateThai(temporary_receipt.date_created)}</div>
												</div>
												<div className="td span2">
													{
														temporary_receipt.approved_user
															? <div>
																<div>{temporary_receipt.approved_user.name}</div>
																<div>{window.Global.getDateThai(temporary_receipt.date_approved)}</div>
															</div>
															: '-'
													}
												</div>
												<div className="td span2">
													<b>{temporary_receipt.summary.total_net_price.format(2)}</b>
												</div>
											</Link>
										)
									})
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	getStatus(temporary_receipt) {
		return (
			<div>
				{
					temporary_receipt.is_void === 1
						? <div className="ui label red">ยกเลิก</div>
						: null
				}
				{
					temporary_receipt.is_void === 0
					&& temporary_receipt.is_approve === null
						? <div className="ui label orange">รอตรวจสอบ</div>
						: null
				}
				{
					temporary_receipt.is_void === 0
					&& temporary_receipt.is_approve === 1
						? <div>
							<div className="ui label green"><i className="icon check"/>ตรวจสอบแล้ว</div>
							<div style={{marginTop: '0.5rem'}}>{temporary_receipt.approved_user.name}</div>
							<div>{window.Global.getDateThai(temporary_receipt.date_approved)}</div>
						</div>
						: null
				}
			</div>
		)
	}

	renderView() {
		return (
			<div ref={(ref) => {
				this.$parent = window.$(ref);
				// Route.setLink();
			}} className="main ui container">
				{
					!this.state.temporary_receipt
						? <div className="ui active centered inline small loader"/>
						: (
							<div>
								<div className="flex row wrap middle-xs">
									<div className="ui huge breadcrumb">
										<Link className="active section"
											  to="/v2/temporary-receipts">ใบเสร็จรับเงินชั่วคราว</Link>
										<span className="divider" style={{margin: '0 1rem'}}>/</span>
										<Link className="section"
											  to={"/v2/temporary-receipts/" + this.state.params.temporary_receipt_id}>{this.state.temporary_receipt.desc}</Link>
									</div>
								</div>
								<div className="ui tall stacked segment">
									<form className="ui form" autoComplete="off">
										<div className="flex row middle-xs"
											 style={{padding: '0 0 9px 0'}}>
											<h2 style={{margin: 0}}>
												{this.state.temporary_receipt.title} {this.state.temporary_receipt.desc}
											</h2>
											<div className="flex row right floated">
												<div className="ui basic gray buttons">
													{/*<div className="ui button"*/}
													{/*     onClick={*/}
													{/*	     () => this.printPdf()*/}
													{/*     }>*/}
													{/*	พิมพ์เอกสาร*/}
													{/*</div>*/}
													{
														this.state.temporary_receipt.is_void === 0
															?
															<div className="ui button"
																 onClick={() => {
																	 window.Global.confirm({
																		 title: 'ยกเลิก',
																		 content: window.Handlebars.compile('<form class="ui form" autocomplete="off">\n\t<p>โปรดยืนยันยกเลิก การกระทำนี้ไม่สามารถกู้ข้อมูลคืนได้</p>\n\t<div class="ui error message"></div>\n</form>')({}),
																		 cancel_text: 'ไม่ดำเนินการ',
																		 approve_text: 'ยกเลิกเอกสาร',
																		 onShowToSetupForm: ($modal) => {
																			 $modal.find('form').form2('setup');
																			 $modal.find('form').form2('submit', {
																				 method: 'DELETE',
																				 url: process.env.REACT_APP_DOMAIN + '/api/v1/temporary_receipt',
																				 loadingButton: $modal.find('.button'),
																				 beforeSent: (data) => {
																					 data.temporary_receipt_id = this.state.temporary_receipt.id;
																					 return data;
																				 },
																				 onSuccess: (response) => {
																					 $modal.modal('hide');
																					 window.Global.messageTop({
																						 type: 'positive',
																						 message: 'ยกเลิกเรียบร้อย'
																					 });
																					 this.setState({
																						 temporary_receipt: response.temporary_receipt
																					 });
																				 }
																			 });
																		 }
																	 });
																 }}>
																ยกเลิก
															</div>
															: null
													}
													{
														this.state.temporary_receipt.is_void === 0
														&& this.state.temporary_receipt.is_approve === null
															? (
																<div className="ui button"
																	 onClick={() => {
																		 window.Global.confirm({
																			 title: 'บันทึกตรวจสอบเรียบร้อย',
																			 content: window.Handlebars.compile('<form class="ui form" autocomplete="off">\n\t<p>โปรดยืนยันบันทึกตรวจสอบเรียบร้อย</p>\n\t<div class="ui error message"></div>\n</form>')({}),
																			 cancel_text: 'ยกเลิก',
																			 approve_text: 'ยืนยัน',
																			 onShowToSetupForm: ($modal) => {
																				 $modal.find('form').form2('setup');
																				 $modal.find('form').form2('submit', {
																					 method: 'PUT',
																					 url: process.env.REACT_APP_DOMAIN + '/api/v1/temporary_receipt/approve',
																					 loadingButton: $modal.find('.button'),
																					 beforeSent: (data) => {
																						 data.temporary_receipt_id = this.state.temporary_receipt.id;
																						 data.is_approve = 1;
																						 return data;
																					 },
																					 onSuccess: (response) => {
																						 $modal.modal('hide');
																						 window.Global.messageTop({
																							 type: 'positive',
																							 message: 'บันทึกตรวจสอบเรียบร้อย'
																						 });
																						 this.setState({
																							 temporary_receipt: response.temporary_receipt
																						 });
																					 }
																				 });
																			 }
																		 });
																	 }}>
																	บันทึกตรวจสอบเรียบร้อย
																</div>
															)
															: null
													}
												</div>
											</div>
										</div>
										<div className="ui divider" style={{margin: '0 0 14px 0'}}/>
										<div className="two fields">
											<div className="field">
												<b>ผู้ขาย</b> {this.state.temporary_receipt.temporary_receipt_header.a_name}
												{
													this.state.temporary_receipt.temporary_receipt_header.a_branch_name
														? ' สาขา ' + this.state.temporary_receipt.temporary_receipt_header.a_branch_name
														: null
												}
												{
													this.state.temporary_receipt.temporary_receipt_header.a_bill_line_1
														?
														<div>{this.state.temporary_receipt.temporary_receipt_header.a_bill_line_1}</div>
														: null
												}
												{
													this.state.temporary_receipt.temporary_receipt_header.a_bill_line_2
														?
														<div>{this.state.temporary_receipt.temporary_receipt_header.a_bill_line_2}</div>
														: null
												}
												{
													this.state.temporary_receipt.temporary_receipt_header.a_tax_number
														?
														<div>เลขประจำตัวผู้เสียภาษี {this.state.temporary_receipt.temporary_receipt_header.a_tax_number}</div>
														: null
												}
											</div>
											<div className="field">
												<b>ลูกค้า</b> {this.state.temporary_receipt.temporary_receipt_header.b_name}
												{
													this.state.temporary_receipt.temporary_receipt_header.b_branch_name
														? ' สาขา ' + this.state.temporary_receipt.temporary_receipt_header.b_branch_name
														: null
												}
												{
													this.state.temporary_receipt.temporary_receipt_header.b_bill_line_1
														?
														<div>{this.state.temporary_receipt.temporary_receipt_header.b_bill_line_1}</div>
														: null
												}
												{
													this.state.temporary_receipt.temporary_receipt_header.b_bill_line_2
														?
														<div>{this.state.temporary_receipt.temporary_receipt_header.b_bill_line_2}</div>
														: null
												}
												{
													this.state.temporary_receipt.temporary_receipt_header.b_tax_number
														?
														<div>เลขประจำตัวผู้เสียภาษี {this.state.temporary_receipt.temporary_receipt_header.b_tax_number}</div>
														: null
												}
											</div>
										</div>
										<div className="flex row wrap padded four column computer">
											<div className="column field">
												<label>วันที่เอกสาร</label>

												<p>{window.Global.getDateThai(this.state.temporary_receipt.doc_date)}</p>
											</div>
											<div className="column field">
												<label>ผู้บันทึก</label>
												<div>
													<p>{this.state.temporary_receipt.created_user.name}</p>
													<p>{window.Global.getDateThai(this.state.temporary_receipt.date_created)}</p>
												</div>
											</div>
											{
												this.state.temporary_receipt.updated_user
													?
													<div className="column field">
														<label>ผู้แก้ไข</label>
														<div>
															<p>{this.state.temporary_receipt.updated_user.name}</p>
															<p>{window.Global.getDateThai(this.state.temporary_receipt.date_updated)}</p>
														</div>
													</div>
													: null
											}
											<div className="column field">
												<label>สถานะ</label>
												{this.getStatus(this.state.temporary_receipt)}
											</div>
										</div>
										<div className="Table_root ui basic table theme1 td-top-xs"
											 style={{marginTop: '1.5rem'}}>
											<div className="thead">
												<div className="tr">
													<div className="th span8">สินค้า</div>
													<div className="th span2">จำนวน</div>
													<div className="th span2">ราคา (฿)</div>
													<div className="th span2">ส่วนลด</div>
													<div className="th span2">ทั้งหมด (฿)</div>
												</div>
											</div>
											<div className="tbody Item_root">
												{
													this.state.temporary_receipt.temporary_receipt_item.map((temporary_receipt_item, i) => {
														return (
															<TemporaryReceiptItem
																key={i}
																temporary_receipt={this.state.temporary_receipt}
																temporary_receipt_item={temporary_receipt_item}
															/>
														)
													})
												}
											</div>
											<div className="tbody OtherItem_root">
												{
													this.state.temporary_receipt.temporary_receipt_item.map((temporary_receipt_item, i) => {
														if (temporary_receipt_item.product_id) {
															return null;
														}
														return (
															<TemporaryReceiptItem
																key={i}
																temporary_receipt={this.state.temporary_receipt}
																temporary_receipt_item={temporary_receipt_item}
															/>
														)
													})
												}
											</div>
										</div>
										<br/>
										<br/>
										<br/>
										<div className="flex row wrap">
											<div className="col-xs-16 col-lg-6">
												{/*<div>*/}
												{/*	<div className="field">*/}
												{/*		<label>หมายเหตุ</label>*/}
												{/*		<p>{this.state.temporary_receipt.remark}</p>*/}
												{/*	</div>*/}
												{/*	<div id="file-upload"></div>*/}
												{/*</div>*/}
											</div>
											<div className="col-xs-16 col-lg-5 flex end-xs right floated">
												<div>
													<div className="flex Summary_root MoneySummary">
														<div className="flex row total-net-price">
															<div>ยอดชำระ</div>
															<div
																className="right">{this.state.temporary_receipt.summary.total_net_price.format(2)}฿
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</form>
								</div>
							</div>
						)
				}
			</div>
		);
	}

	render() {
		if (this.state.mode === 'view') {
			return this.renderView();
		}

		return this.renderList();
	}
}

class TemporaryReceiptItem extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.props.temporary_receipt_item;
	}

	componentDidMount() {
		window.GlobalFunc.setupTax(false, this.$parent, {
			mode: 'view',
			item: this.state,
			disableManageTax: true,
			getTaxType: () => {
				return this.props.temporary_receipt.summary.tax_type;
			}
		});
	}

	render() {
		return (
			<div ref={(ref) => {
				this.$parent = window.$(ref);
			}} className="tr flex row Item_each">
				<div className="td span8">
					<div className="flex row">
						{
							this.state.product
								?
								<img className="ui avatar image"
									 alt=""
									 src={this.state.product.product_image_file_upload.url}/>
								: null
						}
						<div>
							<div>
								{this.state.product ? this.state.product.name : null}
								{this.state.title}
								{
									this.state.temporary_receipt_item_monthly
										? <div>
											{this.state.temporary_receipt_item_monthly.round_desc}
										</div>
										: null
								}
							</div>
							<div className="white-space-pre-line">{this.state.description}</div>
						</div>
					</div>
				</div>
				<div className="td span2">
					<div>
						<div>{this.state.quantity_readable.quantity2}</div>
					</div>
				</div>
				<div className="td span2">
					<div>
						<div>{this.state.price.format(2)}</div>
						<div className="tax-and-withholding-tax-choice"/>
					</div>
				</div>
				<div className="td span2">
					<div>
						<div>{this.state.discount.format(2)}{this.state.discount_type}</div>
					</div>
				</div>
				<div className="td span2">
					<div>
						<div>{this.state.summary.total_price.format(2)}</div>
					</div>
				</div>
			</div>
		)
	}
}